import { useSelector } from '../react';
import { SPLIT_VIEW_FEATURE, selectFeatureFlag } from './featureFlags';

export const useIsSplitViewEnabled = () =>
  useSelector(selectFeatureFlag(SPLIT_VIEW_FEATURE));
